<script>
import useConfig from '../../../../Composables/useConfig.ts'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import ExpandableFields from '../UI/Form/ExpandableFields.vue'
import FormCreator from '../UI/Form/FormCreator.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import { validateNIF } from '../../Utils/string'

export default {
  components: { ExpandableFields, FormCreator, ModalDialog, ButtonAll },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    id: { type: String, required: true },
    endpoint: { type: String, required: false, default: null },
    objectId: { type: Number, required: false, default: null },
    clientId: { type: Number, required: false, default: 0 },
    contractId: { type: Number, required: false, default: null },
    simulationId: { type: Number, required: false, default: null },
    financeId: { type: Number, required: false, default: null },
    entityId: { type: Number, required: false, default: null },
    userId: { type: Number, required: false, default: null },
    userInputId: { type: String, required: false, default: null },
    userEntityId: { type: Number, required: false, default: null },
    userEntityActive: { type: Boolean, required: false, default: false },
    isPlaceholder: { type: Boolean, required: false, default: false },
    edit: { type: Boolean, required: false, default: true },
    add: { type: Boolean, required: false, default: true },
  },

  emits: ['addselect', 'update:user', 'modal-closed'],

  data: () => ({
    userEntity: { user: {} },
    def: {},
    fields: [],
    params: {},
    isNew: false,
    addSending: false,
    sending: false,
    modifySending: false,
    formData: {},
    formBuild: false,
  }),

  setup() {
    const { isTheme } = useConfig()

    return { isTheme }
  },
  computed: {
    getUserInputId() {
      let userInputId = this.userInputId
      if (userInputId.substring(0, 1) !== '#') {
        userInputId = '#' + userInputId
      }
      return userInputId
    },
    getUserInputIdReplacedDots() {
      let userInputId = this.getUserInputId

      return userInputId.replace(/\./g, '-')
    },
    selectElement() {
      const withDashes = $(this.getUserInputIdReplacedDots)
      return withDashes.length > 0 ? withDashes : $(this.getUserInputId)
    },
    userEntityFormRef() {
      return `userEntityForm${this.id ?? ''}${this.entityId ?? ''}`
    },
  },

  methods: {
    updateData(newData) {
      this.formData = newData
      this.setBuild(true)
    },

    setBuild(bool) {
      this.formBuild = bool
    },
    onValidate(data, callback) {
      let errors = []
      const nif = data?.['user.identityNumber']
      const email = data?.['user.email']

      if (email?.length && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
        errors.push({ fieldName: 'user.email', message: 'userEntity.fields.user.email.invalid' })
      }

      if (this.isTheme('itl') && nif && !validateNIF(nif)) {
        errors.push({ fieldName: 'user.identityNumber', message: 'userEntity.fields.user.identityNumber.invalid' })
      }

      callback(errors)
    },
    closeModal() {
      try {
        this.$refs['modalTypeAgent'].close(false)
      } catch (err) {}
      this.$emit('modal-closed')
    },
    finalUserId() {
      if (this.isNew) {
        return 0
      }
      if (this.userId) {
        return this.userId
      } else {
        return this.selectElement.val()
      }
    },
    editModal(isnew) {
      this.isNew = isnew

      if (!isnew) {
        this.modifySending = true
        const finalCheckId = this.finalUserId()
        if (!finalCheckId) {
          this.modifySending = false
          alert(this.$t('userEntity.noUser'))
          return
        }
      } else {
        this.addSending = true
      }

      const contractIdParam = this.contractId != null ? this.contractId : this.objectId
      const userIdForRequest = this.finalUserId()
      const userEntityIdForRequest = this.userEntityId
      this.getJSON(
        'users/' +
          userIdForRequest +
          '/def?contractId=' +
          contractIdParam +
          '&entityId=' +
          this.entityId +
          '&simulationId=' +
          this.simulationId +
          '&financeId=' +
          this.financeId +
          '&userEntityId=' +
          userEntityIdForRequest,
      ).then(
        (json) => {
          this.userEntity = json.userEntity
          this.def = json.config
          this.modifySending = false
          this.addSending = false
          this.formBuild = true
          this.$nextTick(() => {
            this.$refs['modalTypeAgent'].open()
          })
        },
        (reason) => {
          this.modifySending = false
          this.addSending = false
          alert(reason)
        },
      )
    },
    addUser() {
      let form = this.$refs[this.userEntityFormRef]

      if (!form) {
        return
      }

      let data = form.datas
      form.message = { waitingTextT: 'userEntity.waitingText', successTextT: 'userEntity.updateSuccessText' }

      if (!this.isNew) {
        form.datasToRemove['id'] = true
        this.params = {
          entityId: this.entityId,
          contractId: this.contractId,
          simulationId: this.simulationId,
          userEntityId: this.userEntityId,
        }
        this.$nextTick(() => {
          form.methods('patch')
        })
      } else {
        data['entity'] = this.entityId ? this.entityId : this.clientId
        form.methods('post', null, null, 'v2/users/entities')
      }
    },
    isSending(bool) {
      this.sending = bool
    },
    objectReturn({ object, context }) {
      if (object) {
        const id = this.userEntityActive ? object.id : object.user.id

        switch (context) {
          case 'post':
            const newOption = new Option(object.user.name, id, true, true)
            this.selectElement.append(newOption).trigger('change.select2')
            this.$emit('addselect', { data: object, value: id })
            break
          case 'patch': {
            this.selectElement.find(`option[value="${this.finalUserId()}"]`).text(object.user.name)
            this.selectElement.select2({ width: '100%' }).trigger('change.select2')
            this.$emit('update:user', object.user)
            break
          }
          default:
        }

        this.closeModal()
      }
    },
  },
}
</script>
<template>
  <div :id="'add-user-button' + id">
    <div v-if="add || edit" class="btn-group">
      <ButtonAll
        v-if="edit"
        margin="no"
        type="add"
        size="large"
        icon="modify"
        :loading="modifySending"
        style="border-right: 1px solid !important"
        name="userUpdate"
        @click="editModal(false)"
      />
      <ButtonAll
        v-if="add"
        ref="addUser"
        margin="no"
        type="add"
        size="large"
        icon="add"
        :loading="addSending"
        style="border-left: 1px solid !important"
        name="userCreate"
        @click="editModal(true)"
      />
    </div>
    <ModalDialog
      v-if="!isPlaceholder"
      :id="`modal-${userEntityFormRef}`"
      ref="modalTypeAgent"
      :multiple="true"
      class-modal-dialog="modal-lg"
      :id-modal-page="'add-user-button' + id"
      :title="$t(isNew ? 'userEntity.title' : 'userEntity.updateButtonToolTip')"
      e2e-modal="modal"
    >
      <template v-if="userEntity && (userEntity.user || autocomplete)" #body>
        <FormCreator
          endpoint="users"
          dynamic
          send-params
          class-to-add="d-none"
          :id="userEntity.user.id"
          :ref="userEntityFormRef"
          :src-error="userEntityFormRef"
          :params="params"
          :config-def="def"
          :config-object="userEntity"
          @update-data="updateData"
          @object-return="objectReturn"
          @is-sending="isSending"
          @validate="onValidate"
        ></FormCreator>
        <div v-if="formBuild">
          <field-creator
            :form-data="formData"
            name="user.firstname"
            :form-ref="userEntityFormRef"
            domain="userEntity"
            label-top
          />
          <field-creator
            :form-data="formData"
            name="user.lastname"
            :form-ref="userEntityFormRef"
            domain="userEntity"
            label-top
          />
          <field-creator
            v-if="conf.theme_dir == 'itl'"
            :form-data="formData"
            name="user.lastname2"
            :form-ref="userEntityFormRef"
            domain="userEntity"
            label-top
          />
          <field-creator
            :form-data="formData"
            name="user.phone"
            :form-ref="userEntityFormRef"
            domain="userEntity"
            label-top
          />
          <field-creator
            v-if="isTheme('itl')"
            :form-data="formData"
            name="user.identityNumber"
            :form-ref="userEntityFormRef"
            domain="userEntity"
            label-top
          />
          <field-creator
            :form-data="formData"
            name="user.email"
            :form-ref="userEntityFormRef"
            domain="userEntity"
            label-top
          />
          <field-creator
            :form-data="formData"
            name="position"
            :form-ref="userEntityFormRef"
            domain="userEntity"
            label-top
          />
          <ExpandableFields :label="$t('userEntity.fields.more')">
            <field-creator
              :form-data="formData"
              name="user.dateBirth"
              :form-ref="userEntityFormRef"
              domain="userEntity"
              label-top
            />
            <field-creator
              v-if="hasRole('ROLE_REPORTING_VARIABLE')"
              :form-data="formData"
              name="user.reportingVariables"
              :form-ref="userEntityFormRef"
              domain="userEntity"
              select-multiple
              label-top
            />
          </ExpandableFields>
        </div>
      </template>
      <template v-if="!isPlaceholder" #footer>
        <ButtonAll margin="no" type="information" label="button.cancel" name="close" @click="closeModal"></ButtonAll>
        <ButtonAll
          margin="no"
          type="validation"
          :loading="sending"
          label="button.validate"
          name="userValidate"
          @click="addUser"
        ></ButtonAll>
      </template>
    </ModalDialog>
  </div>
</template>
